import { Dispatch, SetStateAction, useCallback } from 'react';
import { ActionMenuItem } from '../../../../components/ActionsMenu/ActionsMenu.types';
import { ITaskGroup } from '../../../../models/taskGroup.types';
import { SubText } from '../../../../components/Prompt/Prompt.component';
import { MessageModal } from '../../ExaminerTreemap.types';
import ActionsMenu from '../../../../components/ActionsMenu/ActionsMenu.component';

export type UseSampleAssessmentGroupMemberActionsMenuProps = {
  setAction: Dispatch<SetStateAction<string>>;
  data: ITaskGroup[];
  selectedItemId: React.MutableRefObject<string>;
  selectedTaskGroup: React.MutableRefObject<ITaskGroup | undefined>;
  setPromptSubTexts: React.Dispatch<React.SetStateAction<SubText[] | undefined>>;
  setPromptMainText: React.Dispatch<React.SetStateAction<string>>;
  setIsConfirmationPromptVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setMessageModal: React.Dispatch<React.SetStateAction<MessageModal>>;
  hasPermissionForGroupTaskActions: boolean;
  setEditExaminerNumberModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useSampleAssessmentGroupMemberActionsMenu = ({
  setAction,
  data,
  selectedItemId,
  selectedTaskGroup,
  setIsConfirmationPromptVisible,
  setPromptMainText,
  setPromptSubTexts,
  hasPermissionForGroupTaskActions,
  setEditExaminerNumberModalOpen,
  setMessageModal,
}: UseSampleAssessmentGroupMemberActionsMenuProps) => {
  const displayRemoveSampleAssessmentGroupMemberAssignmentPrompt = useCallback(() => {
    const taskGroup = data.find((taskGroup) =>
      taskGroup.sampleAssessmentGroup?.sampleAssessmentMembers.find(
        (member) => member.sampleAssessmentMemberId === selectedItemId.current,
      ),
    );
    if (taskGroup) {
      selectedTaskGroup.current = taskGroup;
      setPromptMainText('Czy na pewno chcesz usunąć członka Zespołu Wzorcowych Ocen (ZWO)');
      const subTexts: SubText[] = [
        {
          text: `${
            taskGroup.sampleAssessmentGroup?.sampleAssessmentMembers.find(
              (member) => member.sampleAssessmentMemberId === selectedItemId.current,
            )?.examiner.firstName
          } ${
            taskGroup.sampleAssessmentGroup?.sampleAssessmentMembers.find(
              (member) => member.sampleAssessmentMemberId === selectedItemId.current,
            )?.examiner.lastName
          }`,
        },
      ];
      setPromptSubTexts(subTexts);
      setIsConfirmationPromptVisible(true);
    }
  }, [data]);

  const getSampleAssessmentGroupMemberActionsMenu = useCallback(
    (rowIndex: number): JSX.Element => {
      const menuItems: ActionMenuItem[] = [];

      menuItems.push({
        text: 'Usuń członka ZWO',
        onClick: () => {
          setAction('Usuń członka ZWO');
          displayRemoveSampleAssessmentGroupMemberAssignmentPrompt();
        },
      });
      if (hasPermissionForGroupTaskActions) {
        menuItems.push({
          text: 'Wyślij wiadomość',
          onClick: () => {
            setAction('Wyślij wiadomość');
            setMessageModal({ open: true, type: 'standard' });
          },
        });
      }
      menuItems.push({
        text: 'Edytuj numer egzaminatora',
        onClick: () => {
          setAction('Edytuj numer egzaminatora');
          setEditExaminerNumberModalOpen(true);
        },
      });
      return <ActionsMenu menuItems={menuItems} rowIndex={rowIndex} />;
    },
    [
      displayRemoveSampleAssessmentGroupMemberAssignmentPrompt,
      hasPermissionForGroupTaskActions,
      setAction,
      setMessageModal,
    ],
  );

  return {
    getSampleAssessmentGroupMemberActionsMenu,
  };
};
